export default function onTab(event, editor, next) {
  event.preventDefault();
  var direction = event.shiftKey ? -1 : 1;

  if (!next()) {
    return editor.changeDepth(direction);
  }
}